"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
var react_1 = __importStar(require("react"));
var TextInput_1 = require("../TextInput/TextInput");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var css_1 = require("@emotion/css");
var messages = __importStar(require("./translations"));
var hideRevealButtonStyles = function (selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: unset;\n  border: 1px solid ", ";\n  padding: 0.5rem;\n  display: flex;\n  margin-right: 0.5rem;\n  cursor: pointer;\n\n  &:focus-visible {\n    border-radius: 6px;\n    border-color: ", ";\n    outline: unset;\n  }\n"], ["\n  background-color: unset;\n  border: 1px solid ", ";\n  padding: 0.5rem;\n  display: flex;\n  margin-right: 0.5rem;\n  cursor: pointer;\n\n  &:focus-visible {\n    border-radius: 6px;\n    border-color: ", ";\n    outline: unset;\n  }\n"])), design_system_foundations_1.theme.color.transparent, (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.turquoise70, dark: design_system_foundations_1.darkTheme.color.blueGray50 })); };
var passwordInputStyles = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  input {\n    padding-right: 0px /* let the button handle padding */\n  }\n"], ["\n  input {\n    padding-right: 0px /* let the button handle padding */\n  }\n"])));
var iconColor = function (selectedTheme) { return (selectedTheme === 'dark' ? 'neutral20' : 'neutral100'); };
exports.PasswordInput = react_1.default.forwardRef(function (_a, ref) {
    var className = _a.className, value = _a.value, isDisabled = _a.isDisabled, _b = _a.showCount, showCount = _b === void 0 ? false : _b, _c = _a.isNew, isNew = _c === void 0 ? false : _c, units = _a.units, localeText = _a.localeText, testId = _a.testId, rest = __rest(_a, ["className", "value", "isDisabled", "showCount", "isNew", "units", "localeText", "testId"]);
    var _d = (0, react_1.useState)(false), isRevealed = _d[0], setIsRevealed = _d[1];
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    if (showCount && units) {
        console.warn('Since showCount is true, the units will not be shown.');
    }
    var characterCount = (value === null || value === void 0 ? void 0 : value.length) || 0;
    var characterCountText = (localeText === null || localeText === void 0 ? void 0 : localeText.characters)
        ? "".concat(characterCount, " ").concat(localeText === null || localeText === void 0 ? void 0 : localeText.characters)
        : formatMessage(messages, 'characters', { count: characterCount });
    var iconComponent = isRevealed ? (react_1.default.createElement(design_system_foundations_1.IconSuppress, { size: "sm", color: iconColor(selectedTheme) })) : (react_1.default.createElement(design_system_foundations_1.IconView, { size: "sm", color: iconColor(selectedTheme) }));
    return (react_1.default.createElement(TextInput_1.TextInput, __assign({}, rest, { className: (0, css_1.cx)(className, passwordInputStyles, 'ds-password-input'), ref: ref, testId: testId, isDisabled: isDisabled, type: isRevealed ? 'text' : 'password', autoComplete: isNew ? 'new-password' : 'current-password', value: value, units: showCount && !isDisabled ? characterCountText : units, endAdornment: !isDisabled && value ? (react_1.default.createElement("button", { "aria-label": isRevealed ? formatMessage(messages, 'hidePassword') : formatMessage(messages, 'showPassword'), className: hideRevealButtonStyles(selectedTheme), onClick: function () { return setIsRevealed(function (revealed) { return !revealed; }); }, type: "button" }, iconComponent)) : undefined })));
});
exports.PasswordInput.displayName = 'PasswordInput';
var templateObject_1, templateObject_2;
